<template lang="pug">
  v-container.fill-height.justify-center.align-center(fluid)
    v-snackbar( v-model="snackBar" :color="snackBarColor" ) {{ snackBarMessage }}
      template( v-slot:action="{attrs}")
        v-btn(text v-bind="attrs" @click="snackBar = false")
          v-icon fas fa-times

    v-card.fill-height(flat max-width="450px" )
      v-form(v-model="isFormValid" :disabled="isSaveInProgress" @submit.prevent="onSubmitButtonClick")
        v-card-title {{ $t('changePinPage.pageLabel') }}
        v-card-subtitle.mt-1 {{ $t('changePinPage.pageSublabel') }}
        v-card-text.fill-height.mb-0
          v-row.ma-0
            v-col.pa-0.pb-2(cols="12")
              span.text--secondary {{$t('validation.valueIsRequiredMessage')}}
          v-row.ma-0
            v-col.pa-0(cols="12" sm="12" md="6" lg="6" xl="6")
              v-text-field(
                v-model="password" outlined :autofocus="true" :rules="passwordRules"
              )
            v-col(cols="4" v-if="this.$vuetify.breakpoint.mdAndUp")
              v-btn(type="button" @click="generateCodeClick" medium) {{$t('changePinPage.generatePassword')}}
            v-col.text-center(cols="12" v-else)
              v-btn(type="button" @click="generateCodeClick" medium) {{$t('changePinPage.generatePassword')}}
        v-card-actions(v-if="this.$vuetify.breakpoint.mdAndUp")
          v-spacer
          v-row.ma-0.mt-0
            v-spacer
            v-col.text-end.pr-12(cols="6")
              v-btn(
                color="primary"
                type="submit"
                :disabled="!isFormValid" :loading="isSaveInProgress"
              ) {{ $t('changePinPage.submitButtonLabel') }}
        v-card-actions(v-else)
          v-row.ma-0.fill-height
            v-col(cols="12")
              v-btn(
                block
                color="primary"
                type="submit"
                :disabled="!isFormValid" :loading="isSaveInProgress"
              ) {{ $t('changePinPage.submitButtonLabel') }}

</template>

<script lang="ts">
import Vue from 'vue'
import {Component} from 'vue-property-decorator'
import {Action} from 'vuex-class'
import {AUTH_CHANGE_PIN} from "@/store/action-types";
import {ChangePasswordPayload} from "@/types/payload";
import {TranslateResult} from "vue-i18n";
import {setSetting} from "@/services/settings";
import i18n from "@/plugins/i18n";

@Component({})
export default class ChangePinPage extends Vue {
  private isFormValid: boolean = false
  private isSaveInProgress: boolean = false
  private password: string | null = null
  private passwordRules: Array<(v: string) => string | boolean | TranslateResult> = [
    (v: string) => !!v || i18n.t('validation.valueIsRequired').toString(),
    (v: string) => (v && v.length > 3)  || i18n.t('validation.passwordValidationText').toString(),
    (v: string) => {
      const pattern = /^[a-zA-Z0-9]*$/

      return pattern.test(v) || i18n.t('validation.valueIsRequired').toString()
    },
  ]
  private snackBar: boolean = false
  private snackBarMessage: string = ''
  private snackBarColor: string = ''

  @Action(AUTH_CHANGE_PIN) saveNewPin!: ({ (payload: ChangePasswordPayload): Promise<void> })

  generateCodeClick () {
    this.password = Math.floor(1000 + Math.random() * 9000).toString()
  }

  async onSubmitButtonClick(): Promise<void> {
    const payload: ChangePasswordPayload = {
      password: this.password!.toString(),
      isForced: true
    }
    try {
      this.isSaveInProgress = true

      await this.saveNewPin(payload)

      setSetting('boarder.force_pin_change', false)

      this.$router.push({name: 'Dashboard'})
    } catch (e) {
      this.snackBar = true
      this.snackBarColor="error"
      this.snackBarMessage=this.$t('changePinPage.saveDataMessage').toString()
    } finally {
      this.isSaveInProgress = false
      this.snackBar = true
      this.snackBarColor="success"
      this.snackBarMessage=this.$t('changePinPage.saved').toString()
    }
  }
}
</script>

<style lang="stylus" scoped>
.pin-number-field
  max-width 64px
  font-size x-large

</style>
